import React from 'react';

export default function PageLoader({
    label = 'Loading data…',
    helperText = 'This will only take a second.',
}) {
    return (
        <div className="flex min-h-[260px] items-center justify-center">
            <div className="w-full max-w-md rounded-2xl border border-slate-100 bg-white/90 p-8 shadow-xl ring-1 ring-slate-100">
                <div className="flex flex-col items-center text-center">
                    <div className="relative mb-6 inline-flex h-20 w-20 items-center justify-center">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-slate-200 opacity-60" />
                        <span className="absolute inline-flex h-14 w-14 rounded-full bg-gradient-to-tr from-slate-900 via-slate-700 to-slate-600 opacity-80 blur-md" />
                        <span className="relative inline-flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-slate-900 to-slate-700 text-white shadow-lg">
                            <span className="h-7 w-7 animate-spin rounded-full border-2 border-white/30 border-t-white"></span>
                        </span>
                    </div>
                    <p className="text-base font-semibold text-slate-900">{label}</p>
                    <p className="mt-2 text-sm text-slate-500">{helperText}</p>
                </div>
            </div>
        </div>
    );
}
